import stats from "@/data/forms/mixins/stats.js";
import { mapGetters } from "vuex";

export default {
  ...mapGetters(["getStatsRemote"]),
  mixins: [stats],
  methods: {
    enableStatsRemote(tag) {
      // REMOTE STATS CHECK = TRUE OR FALSE
      let logic = null;
      if (tag === "A1" || tag === "C1" || tag === "F1" || tag === "U1") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    defineStatsRemote(tag) {
      let stats = null;
      if (tag === "A1") {
        stats = this.formStatsAsset;
      }
      if (tag === "C1") {
        stats = this.formStatsCompany;
      }
      if (tag === "F1") {
        stats = this.formStatsFacility;
      }
      if (tag === "U1") {
        stats = this.formStatsUser;
      }
      return stats;
    },
    compareStats(local, remote) {
      // DEFINE local / remote stats
      let stat = null;
      // CHECK
      if (local > remote) {
        stat = local;
      } else if (local === remote) {
        stat = local;
      } else {
        // change made other
        // this change increment by 1;
        stat = remote;
      }
      return stat;
    },
    selectStats(local, remote) {
      // DEFINE STATS
      // local is deafult as it includes latest edit / due dates
      // remote counter and overwrite local counters
      let stats = local;

      if (local !== null && remote !== null) {
        // STATS- ASSET REGISTER
        if (local.na1 !== undefined && remote.na1 !== undefined) {
          stats.na1 = this.compareStats(local.na1, remote.na1);
        }

        // STATS - RISK ANALYSIS
        if (local.nb1 !== undefined && remote.nb1 !== undefined) {
          stats.nb1 = this.compareStats(local.nb1, remote.nb1);
        }

        // STATS - ACTION REGISTER
        if (local.nb3 !== undefined && remote.nb3 !== undefined) {
          stats.nb3 = this.compareStats(local.nb3, remote.nb3);
        }

        // STATS - ACTION OPEN REGISTER
        if (local.nb3o !== undefined && remote.nb3o !== undefined) {
          stats.nb3o = this.compareStats(local.nb3o, remote.nb3o);
        }

        // STATS - BUDGET REGISTER
        if (local.nb4 !== undefined && remote.nb4 !== undefined) {
          stats.nb4 = this.compareStats(local.nb4, remote.nb4);
        }

        // STATS - BUDGET OPEN REGISTER
        if (local.nb4o !== undefined && remote.nb4o !== undefined) {
          stats.nb4o = this.compareStats(local.nb4o, remote.nb4o);
        }

        // STATS - PLAN REGISTER
        if (local.nb6 !== undefined && remote.nb6 !== undefined) {
          stats.nb6 = this.compareStats(local.nb6, remote.nb6);
        }

        // STATS - PLAN OPEN REGISTER
        if (local.nb6o !== undefined && remote.nb6o !== undefined) {
          stats.nb6o = this.compareStats(local.nb6o, remote.nb6o);
        }

        // STATS - BUSIENSS LIMITS
        if (local.nb7 !== undefined && remote.nb7 !== undefined) {
          stats.nb7 = this.compareStats(local.nb7, remote.nb7);
        }

        // STATS - LOG
        if (local.nd3 !== undefined && remote.nd3 !== undefined) {
          stats.nd3 = this.compareStats(local.nd3, remote.nd3);
        }

        // STATS - LOG ATTENTION
        if (local.nd3a !== undefined && remote.nd3a !== undefined) {
          stats.nd3a = this.compareStats(local.nd3a, remote.nd3a);
        }

        // STATS - LOG UNREAD
        if (local.nd3u !== undefined && remote.nd3u !== undefined) {
          stats.nd3u = this.compareStats(local.nd3u, remote.nd3u);
        }

        // STATS - ATTACHMENTS
        if (local.nd4 !== undefined && remote.nd4 !== undefined) {
          stats.nd4 = this.compareStats(local.nd4, remote.nd4);
        }

        // STATS - EQUIPMENT REGISTER
        if (local.ne1 !== undefined && remote.ne1 !== undefined) {
          stats.ne1 = this.compareStats(local.ne1, remote.ne1);
        }

        // STATS - ENG. REQUEST
        if (local.ne2 !== undefined && remote.ne2 !== undefined) {
          stats.ne2 = this.compareStats(local.ne2, remote.ne2);
        }

        // STATS - ENG. REQUEST OPEN
        if (local.ne2o !== undefined && remote.ne2o !== undefined) {
          stats.ne2o = this.compareStats(local.ne2o, remote.ne2o);
        }

        // STATS - ENGINGEERING ANALYSIS
        if (local.ne3 !== undefined && remote.ne3 !== undefined) {
          stats.ne3 = this.compareStats(local.ne3, remote.ne3);
        }

        // STATS - RESULTS MANAGEMENT
        if (local.ne5 !== undefined && remote.ne5 !== undefined) {
          stats.ne5 = this.compareStats(local.ne5, remote.ne5);
        }

        // STATS - INSPECTION and TEST PROGRAM
        if (local.ne6 !== undefined && remote.ne6 !== undefined) {
          stats.ne6 = this.compareStats(local.ne6, remote.ne6);
        }

        // STATS - FACILITY REGISTER
        if (local.nf1 !== undefined && remote.nf1 !== undefined) {
          stats.nf1 = this.compareStats(local.nf1, remote.nf1);
        }

        // STATS - ROLES
        if (local.ng4 !== undefined && remote.ng4 !== undefined) {
          stats.ng4 = this.compareStats(local.ng4, remote.ng4);
        }

        // STATS - SKILLS
        if (local.nh1 !== undefined && remote.nh1 !== undefined) {
          stats.nh1 = this.compareStats(local.nh1, remote.nh1);
        }

        // STATS - COMPETENCIES
        if (local.nh2 !== undefined && remote.nh2 !== undefined) {
          stats.nh2 = this.compareStats(local.nh2, remote.nh2);
          console.log("NH2");
          console.log(stats.nh2);
        }

        // STATS - CERTS
        if (local.nh3 !== undefined && remote.nh3 !== undefined) {
          stats.nh3 = this.compareStats(local.nh3, remote.nh3);
        }

        // STATS - LICENCES
        if (local.nh4 !== undefined && remote.nh4 !== undefined) {
          stats.nh4 = this.compareStats(local.nh4, remote.nh4);
        }

        // STATS - RESOURCES ESTIMATE
        if (local.nh5 !== undefined && remote.nh5 !== undefined) {
          stats.nh5 = this.compareStats(local.nh5, remote.nh5);
        }

        // STATS - IMPORTS REGISTER
        if (local.nk4 !== undefined && remote.nk4 !== undefined) {
          stats.nk4 = this.compareStats(local.nk4, remote.nk4);
        }

        // STATS - MATERIAL REGISTER
        if (local.nl1 !== undefined && remote.nl1 !== undefined) {
          stats.nl1 = this.compareStats(local.nl1, remote.nl1);
        }

        // RELPS - MATERIAL BOM
        if (local.nl2 !== undefined && remote.nl2 !== undefined) {
          stats.nl2 = this.compareStats(local.nl2, remote.nl2);
        }

        // STATS - PARTS LIST
        if (local.nl5 !== undefined && remote.nl5 !== undefined) {
          stats.nl5 = this.compareStats(local.nl5, remote.nl5);
        }

        // STATS - INVENTORY LIST
        if (local.nl7 !== undefined && remote.nl7 !== undefined) {
          stats.nl7 = this.compareStats(local.nl7, remote.nl7);
        }

        // STATS - MAINT ACTIVITY
        if (local.nm1 !== undefined && remote.nm1 !== undefined) {
          stats.nm1 = this.compareStats(local.nm1, remote.nm1);
        }

        // STATS - MAINT STRATEGY
        if (local.nm2 !== undefined && remote.nm2 !== undefined) {
          stats.nm2 = this.compareStats(local.nm2, remote.nm2);
        }

        // STATS - MAINT PLAN
        if (local.nm7 !== undefined && remote.nm7 !== undefined) {
          stats.nm7 = this.compareStats(local.nm7, remote.nm7);
        }

        // STATS - OPS NOTI
        if (local.no1 !== undefined && remote.no1 !== undefined) {
          stats.no1 = this.compareStats(local.no1, remote.no1);
        }

        // STATS - OPS NOTI
        if (local.no1o !== undefined && remote.no1o !== undefined) {
          stats.no1o = this.compareStats(local.no1o, remote.no1o);
        }

        // STATS - PERMIT REQUESTS
        if (local.no5 !== undefined && remote.no5 !== undefined) {
          stats.no5 = this.compareStats(local.no5, remote.no5);
        }

        // STATS - ORDER
        if (local.nq1 !== undefined && remote.nq1 !== undefined) {
          stats.nq1 = this.compareStats(local.nq1, remote.nq1);
        }

        // STATS - ORDER OPEN REGISTER
        if (local.nq1o !== undefined && remote.nq1o !== undefined) {
          stats.nq1o = this.compareStats(local.nq1o, remote.nq1o);
        }

        // RELPS HAZARD - REGISTER
        if (local.ns1 !== undefined && remote.ns1 !== undefined) {
          stats.ns1 = this.compareStats(local.ns1, remote.ns1);
        }

        // STATS - RISK ASSESSMENTS
        if (local.ns2 !== undefined && remote.ns2 !== undefined) {
          stats.ns2 = this.compareStats(local.ns2, remote.ns2);
        }

        // STATS INCIDENT - COUNTER
        if (local.ns6 !== undefined && remote.ns6 !== undefined) {
          stats.ns6 = this.compareStats(local.ns6, remote.ns6);
        }

        // STATS INCIDENT OPEN - COUNTER
        if (local.ns6o !== undefined && remote.ns6o !== undefined) {
          stats.ns6o = this.compareStats(local.ns6o, remote.ns6o);
        }

        // STATS - USERS COUNT
        if (local.nu1 !== undefined && remote.nu1 !== undefined) {
          stats.nu1 = this.compareStats(local.nu1, remote.nu1);
        }

        // STATS - WORK REQUEST
        if (local.nw1 !== undefined && remote.nw1 !== undefined) {
          stats.nw1 = this.compareStats(local.nw1, remote.nw1);
        }

        // STATS - WORK REQUEST OPEN
        if (local.nw1o !== undefined && remote.nw1o !== undefined) {
          stats.nw1o = this.compareStats(local.nw1o, remote.nw1o);
        }

        // STATS - WORK CALL
        if (local.nw2 !== undefined && remote.nw2 !== undefined) {
          stats.nw2 = this.compareStats(local.nw2, remote.nw2);
        }

        // STATS - WORK CALL OPEN
        if (local.nw2o !== undefined && remote.nw2o !== undefined) {
          stats.nw2o = this.compareStats(local.nw2o, remote.nw2o);
        }

        // STATS - TASK LIST
        if (local.nw5 !== undefined && remote.nw5 !== undefined) {
          stats.nw5 = this.compareStats(local.nw5, remote.nw5);
        }

        // PROCEDURES - USERS COUNT
        if (local.nw6 !== undefined && remote.nw6 !== undefined) {
          stats.nw6 = this.compareStats(local.nw6, remote.nw6);
        }

        // MISC.
        if (local.nlike !== undefined && remote.nlike !== undefined) {
          stats.nlike = this.compareStats(local.nlike, remote.nlike);
        }
        if (local.nrate !== undefined && remote.nrate !== undefined) {
          stats.nrate = this.compareStats(local.nrate, remote.nrate);
        }
        if (local.nread !== undefined && remote.nread !== undefined) {
          stats.nread = this.compareStats(local.nread, remote.nread);
        }
        if (local.n !== undefined && remote.n !== undefined) {
          stats.n = this.compareStats(local.n, remote.n);
        }
        if (local.nctr !== undefined && remote.nctr !== undefined) {
          stats.nctr = this.compareStats(local.nctr, remote.nctr);
        }

        // RETURN
        return stats;
      }
    },
    calcStatsWorkStatus(status, list) {
      // HELP
      // console.log("");
      // console.log("CALC STATS WORK STATUS");
      // console.log(status);
      // console.log(list);
      let ctr = 0;
      // add counter based on status
      if (list !== null && status !== null) {
        for (var i = 0; i < list.length; i++) {
          if (status === list[i].char.status) {
            ctr = ctr + 1;
          }
        }
      }
      // make ctr for single and double digits the same
      return ctr;
    }
  }
};
